// =============================================================
// App.js — Ana uygulama (güncellenmiş: diyetisyen + otorecipe)
// =============================================================
import React, { useState } from "react";
import { AppProvider } from "./context/AppContext";
import { I18nProvider } from "./context/I18nContext";
import Navbar from "./components/Navbar";
import AdConsentBanner from "./components/AdConsentBanner";
import DailyPlan from "./pages/DailyPlan";
import AllMeals from "./pages/AllMeals";
import Desserts from "./pages/Desserts";
import AddRecipe from "./pages/AddRecipe";
import ShoppingList from "./pages/ShoppingList";
import Favorites from "./pages/Favorites";
import MealDetail from "./pages/MealDetail";
import Dietitian from "./pages/Dietitian";
import AdminPanel from "./pages/AdminPanel";
import IngredientSuggest from "./pages/IngredientSuggest";
import Profile from "./pages/Profile";
import NutritionSearch from "./pages/NutritionSearch";
import LegalPage from "./pages/LegalPage";
import "./styles.css";

export default function App() {
  const [page, setPage] = useState("daily");
  const [selectedMeal, setSelectedMeal] = useState(null);

  const navigate = (p, meal = null) => {
    setSelectedMeal(meal);
    setPage(p);
    window.scrollTo(0, 0);
  };

  return (
    <I18nProvider>
      <AppProvider>
        <div className="app">
          <Navbar page={page} navigate={navigate} />
          <AdConsentBanner />
          <main className="main-content">
            {page === "daily"      && <DailyPlan navigate={navigate} />}
            {page === "meals"      && <AllMeals navigate={navigate} />}
            {page === "desserts"   && <Desserts navigate={navigate} />}
            {page === "addRecipe"  && <AddRecipe navigate={navigate} />}
            {page === "ingredients" && <IngredientSuggest navigate={navigate} />}
            {page === "nutrition"  && <NutritionSearch />}
            {page === "shopping"   && <ShoppingList />}
            {page === "favorites"  && <Favorites navigate={navigate} />}
            {page === "detail"     && <MealDetail meal={selectedMeal} navigate={navigate} />}
            {page === "dietitian"  && <Dietitian />}
            {page === "profile"    && <Profile navigate={navigate} />}
            {page === "admin"      && <AdminPanel navigate={navigate} />}
            {page === "legal"      && <LegalPage navigate={navigate} />}
          </main>
        </div>
      </AppProvider>
    </I18nProvider>
  );
}
